<template>
    <div class="widthBox">
        <h1 class="txt txt_center mt_80 mb_90" style="font-size: 28px !important;">{{ $t("Introduction of core members") }} </h1>
        <el-row :gutter="10" class="acea-row mb_40" v-for="(item,index) in recommend_team_list" :key="index" >
            <el-col :span="6" :xs="8">
                <img class="img100 radius-8" :src="item.thumbnail_url" alt="">
            </el-col>
            <el-col :span="16" :xs="14" :offset="1" class="">
                <div class="mt_40 txt f-20">{{item.name}}</div>
                <div class="mt_8 info3 acea-row row-between">
                    <div class=" f-16 ">{{item.position}}</div>
                    <div class="  cursor acea-row row-between hidden-sm-and-up" @click="(item.show = !item.show)">
                        <div class="hidden-xs-only f-16">{{ item.show ? 'brief content' : 'show all' }} </div>
                        <img v-if="!item.show" src="@/assets/arrow_bottom2.png" style="width: 20px;height: 20px;" alt="">
                        <img v-if="item.show" src="@/assets/arrow_top2.png" style="width: 20px;height: 20px;" alt="">
                    </div>
                </div>
                <div class="mt_20 info" :class="item.show ? '' : 'ellipsis'" v-html="item.desc"></div>
            </el-col>
        </el-row>
        <h1 class="txt txt_center mt_80 mb_48" style="font-size: 28px !important;">{{$t("Other members")}}</h1>

        <div ref="imgs" class="imgs" id="imgs">
            <div v-for="(item,index) in other_team_list" :key="index" @click="(member = item)" class="img cursor radius-8" :class="item.id ==  member.id ? 'arrow' : ''" >
                <img class="img100 radius-8" draggable="false" style="object-fit:unset" :src="item.thumbnail_url" alt="" :class="item.id ==  member.id ? 'red_border' : ''" >
            </div>
        </div>

        <el-row :gutter="10" class="acea-row mb_40">
            <el-col :span="6" :xs="8">
                <img class="img100 radius-8" :src="member.thumbnail_url" alt="">
            </el-col>
            <el-col :span="16" :xs="14" :offset="1" class="">
                <div class="mt_40 txt f-20">{{member.name}}</div>
                <div class="mt_8 info3 acea-row row-between">
                    <div class=" f-16 ">{{member.position}}</div>
                    <div class="cursor acea-row row-between hidden-sm-and-up" @click="(member.show = !member.show)">
                        <div class="hidden-xs-only f-16">{{ member.show ? 'brief content' : 'show all' }} </div>
                        <img v-if="!member.show" src="@/assets/arrow_bottom2.png" style="width: 20px;height: 20px;" alt="">
                        <img v-if="member.show" src="@/assets/arrow_top2.png" style="width: 20px;height: 20px;" alt="">
                    </div>
                </div>
                <div class="mt_20 info" :class="member.show ? '' : 'ellipsis'" v-html="member.desc"></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Drag from '../../utils/move';
export default {
    name: "OurTeam",
    data(){
        return{
            recommend_team_list:[],
            other_team_list:[],
            member:{}
        }
    },
    mounted(){
        new Drag(this.$refs.imgs);
    },
    created(){
        this.get_info();
    },
    methods:{
        async get_info(){
            let res = await this.$api.get("api/company.Team/list", {id:this.id});
            res.data.recommend_team_list.forEach(element => {
                element.show = false
            });
            this.recommend_team_list = res.data.recommend_team_list;
            res.data.other_team_list.forEach(element => {
                element.show = false
            });
            this.other_team_list = res.data.other_team_list;
            this.member = res.data.other_team_list[0]
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.mt_80 {
    margin-top: 80px;
}

.mb_120 {
    margin-bottom: 120px;
}
.mb_90 {
    margin-bottom: 90px;
}
.mb_40{
    margin-bottom: 40px;
}
.mb_48{
    margin-bottom: 48px;
}
.mt_40{
    margin-top: 40px;
}
.mt_8{
    margin-top: 8px;
}
.mt_20{
    margin-top: 20px;
}
.imgs{
    width: 100%;
    white-space: nowrap;
    margin-bottom: 86px;
    overflow: auto;
    overflow-x: hidden;
}
.imgs::-webkit-scrollbar {
  display: none; /* 隐藏滚动条在 Chrome、Safari 和 Opera */
}
.img{
    width: calc(100% / 7 - 10px);
    display: inline-block;
    margin-right: 12px;
    margin-bottom: 20px;
    position: relative;
    vertical-align: top;
    
    img{
        height: 100%;
    }
    // cursor: grabbing;
    // cursor: -moz-grabbing;
    // cursor: -webkit-grabbing;
    // pointer-events:none;
}
.img:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}
.red_border{
    box-sizing: border-box;
    border: 4px solid #B50900;
}
.arrow::before{
    content:'';//一定要有它，否则效果出不来
    position:absolute;//给高亮元素定位，在这之前要给statusItem元素设置position:relative定位
    left:50%;
    bottom:-16px;
    transform: translate(-50%,0);//居中显示
    border:10px solid transparent;//小三角的大小
    border-top-color:#B50900;//小三角朝下
    
}
.ellipsis {
    
}

@media screen and(max-width:768px) {
    .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    }

    .mb_120 {
        margin-bottom: 56px;
    }
    .mt_40{
        margin-top: 0px;
    }
    .mb_48{
        margin-bottom: 20px;
    }
    .f-16{
        font-size: 12px;
    }
    .mt_8{
        margin-top: 4px;
    }
    .mt_80 {
        margin-top: 56px;
    }
    .mt_20{
        margin-top: 8px;
    }
    .mb_40{
        margin-bottom: 32px;
    }
    .img{
        width: calc(100% / 3.5 - 10px);
        margin-right: 12px;
    }
    .red_border{
        box-sizing: border-box;
        border: 2px solid #B50900;
    }
    .arrow::before{
        content:'';//一定要有它，否则效果出不来
        position:absolute;//给高亮元素定位，在这之前要给statusItem元素设置position:relative定位
        left:50%;
        bottom:-15px;
        transform: translate(-50%,0);//居中显示
        border:10px solid transparent;//小三角的大小
        border-top-color:#B50900;//小三角朝下
        
    }
}
</style>